export const GET_SHOP_INFO = "auth/GET_SHOP_INFO";
export const GET_FULL_SHOP_INFO = "auth/GET_FULL_SHOP_INFO";

export const SET_TOKEN = "auth/SET_TOKEN";
export const SET_REFRESH_TOKEN = "auth/SET_REFRESH_TOKEN";
export const SET_USER = "auth/SET_USER";
export const SET_LOGIN_STATUS = "auth/SET_LOGIN_STATUS";
